// Resumo do cadastro em lote para o toast: "3 plantões registrados, 1 data já tinha
// plantão". O backend pula (não duplica) as datas em que o vínculo já tinha plantão.
export function describeBatchResult({ criados = [], pulados = [] }) {
  const registrados =
    criados.length === 0
      ? "Nenhum plantão novo registrado"
      : criados.length === 1
        ? "1 plantão registrado"
        : `${criados.length} plantões registrados`;
  if (pulados.length === 0) return registrados;
  const jaTinham = pulados.length === 1 ? "1 data já tinha plantão" : `${pulados.length} datas já tinham plantão`;
  return `${registrados}, ${jaTinham}`;
}
